import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import '../styles/index.scss'
import { toAbsoluteUrl } from '../../../../_metronic/helpers/AssetHelpers'
import TextInput from '../../widgets/components/Input/TextInput'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useIntl } from 'react-intl'
import { SelectInput } from '../../widgets/components/Input/SelectInput'
// import {CustomButton} from '../../widgets/components/UI/CustomButton'
import { profileData, updateProfileInfo } from '../core/_requests'
import { FileUpload } from '../../widgets/components/FileUpload'
import { designationOptions, userInitialValues } from '../core/_constants'
import { useAuth } from '../../auth'
// import { ChangePasswordModal } from '../../auth/components/ChangePasswordModal'
// import { forgotPassword } from '../../auth/core/_requests'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { toast } from 'react-toastify'
// import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
// import { BasicButton } from '../../widgets/components/UI/BasicButton'
import Skeleton from 'react-loading-skeleton'
import TagManager from 'react-gtm-module'
import { GTMEvent, emailVerificationMeta } from '../../../hooks/gtmHelpers'
import { createOtp, getLocation } from '../../onboarding/core/_requests'
import { InputWithPhone } from '../../widgets/components/Input/InputPhone'
import { useGetAllDropdownData } from '../../../hooks/useGetAllDropdownData'
import { ShareholdersTypes } from '../../stakeholders/stakeholders-and-investors/core/_constants'
import parsePhoneNumberFromString, { isValidPhoneNumber } from 'libphonenumber-js'
import OTPModal from './OTPModal'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import { removeNullFields } from '../../../core/_util'

export function User({
  key,
  setImgName,
  imgName,
  getApiLoading,
  countryOptions,
  stateOptions,
  countryCode,
  phoneNumber,
  getProfileInfo,
  setCountryId,
}: {
  key: number
  setImgName: Dispatch<SetStateAction<string | undefined>>
  imgName: string | undefined
  getApiLoading: boolean
  countryOptions: any
  stateOptions: any
  countryCode?: string
  phoneNumber?: string
  getProfileInfo?: any
  setCountryId: Dispatch<SetStateAction<string | undefined>>
}) {
  const isRecordskeeper = process.env.REACT_APP_BRAND === 'RK'
  const { formatMessage } = useIntl()
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const { companyId, currentUser, setCurrentUser } = useAuth()
  // const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const { phoneCodesOptions } = useGetAllDropdownData(ShareholdersTypes.INDIVIDUAL)
  // const [changePasswordLoading, setChangePasswordLoading] = useState(false)
  // const [, setHasErrors] = useState<boolean | undefined>()
  const [ipStackData, setIpStackData] = useState<any>()
  const [showModal, setShowModal] = useState<boolean>(false)
  const [newCountryCode, setNewCountryCode] = useState<string>('')
  const [newPhone, setNewPhone] = useState<string>('')

  const userSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(3, formatMessage({ id: 'Minimum 3 characters' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'First name is required' })),
    lastName: Yup.string()
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'Last name is required' })),
    email: Yup.string()
      .email(formatMessage({ id: 'Invalid email format' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'Email is required' })),
    contactNumber: Yup.string()
      .nullable()
      .test('phone-number-valid', 'Invalid phone number', function (value, ctx: any) {
        if (!value || value === '') return true

        const selectedPhoneCode = ctx.parent.countryDialingCode
        const selectedCountryCode = phoneCodesOptions.find(
          (option: any) => option.dial_code === selectedPhoneCode
        )?.code

        if (phoneCodesOptions.length === 0 && ctx.originalValue) {
          return true // Invalid phone code
        }

        try {
          const phoneNumber = String(ctx.originalValue)
          const parsedNumber = parsePhoneNumberFromString(phoneNumber, selectedCountryCode)

          return isValidPhoneNumber(parsedNumber?.number as string)
        } catch (error) {
          return false
        }
      }),
    communication: Yup.object().shape({
      email: Yup.bool(),
      phone: Yup.bool(),
    }),
    country: Yup.string()
      .required(formatMessage({ id: 'Country is required' }))
      .nullable(),
    state: Yup.string()
      .required(formatMessage({ id: 'State/Province is required' }))
      .nullable(),
    city: Yup.string()
      .required(formatMessage({ id: 'City is required' }))
      .nullable(),
    zipCode: Yup.number()
      .required(formatMessage({ id: 'Zip Code is required' }))
      .nullable(),
  })

  useEffect(() => {
    const fetchIpStackData = async () => {
      try {
        const ipStackData = await getLocation()
        setIpStackData(ipStackData.data)
      } catch (err) {
        console.log(err)
      }
    }
    fetchIpStackData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (values: any) => {
    try {
      setLoading(true)
      const payload: any = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        designation: values.designation,
        country: values.country, // Ensuring country is parsed as an integer
        communication: values.communication,
        companyId,
        countryDialingCode: values.countryDialingCode,
        contactNumber: values.contactNumber,
        stateId: values.state,
        city: values.city,
        zipCode: values.zipCode,
      }
      if (values.profileImageId) {
        payload.profileImageId = values.profileImageId
      }
      let {
        data: { success, errors },
      } = await updateProfileInfo(payload)
      if (success) {
        if (companyId) {
          const {
            data: { success, data, errors },
          } = await profileData(companyId)
          if (success) {
            setCurrentUser({
              ...currentUser,
              firstName: data.firstName,
              profileImg: data.profileImage,
            })
            setImgName(data.profileImage)
            const communicationData = JSON.parse(data.communication)
            userInitialValues.firstName = data.firstName
            userInitialValues.lastName = data.lastName
            userInitialValues.email = data.email
            userInitialValues.contactNumber = data.contact
            userInitialValues.countryDialingCode = data.countryDialingCode
            userInitialValues.country = data.countryId!
            userInitialValues.designation = data.designation
            userInitialValues.profileImageId = data.profileImageId!
            userInitialValues.communication.email = communicationData?.email || false
            userInitialValues.communication.phone = communicationData?.phone || false
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.UserSettingsUpdatedSuccessful,
                metadata: removeNullFields({
                  country_name: ipStackData?.country_name || 'NA',
                  region_name: ipStackData?.region_name || 'NA',
                  city_name: ipStackData?.city || 'NA',
                  postcode: ipStackData?.zip || 111111,
                  ...emailVerificationMeta({
                    ...data,
                    userId: currentUser?.userId,
                    profileImg: data.profileImage,
                  }),
                  designation: data.designation,
                  communication_email: communicationData?.email || false,
                  communication_phone: communicationData?.phone || false,
                }),
              },
            })
          } else if (errors) {
            errors.forEach((error: string) => {
              toast.error(formatMessage({ id: error }))
            })
          }
        }
        setLoading(false)
        toast.success(formatMessage({ id: 'Profile updated successfully' }))
      } else if (errors) {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.UserSettingsUpdatedFailed,
            metadata: removeNullFields({
              errors: errors,
              user_id: companyId,
            }),
          },
        })
        setLoading(false)
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const saveChanges = (values: any) => {
    if (
      (phoneNumber !== values.contactNumber && isRecordskeeper) ||
      (countryCode !== values.countryDialingCode && isRecordskeeper)
    ) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.PhoneVerificationStartSuccessful,
          metadata: {
            user_id: currentUser?.userId,
            user_hash: currentUser?.user_hash,
            email: currentUser?.email,
            phone: `${values?.countryDialingCode}${values?.contactNumber}`,
            company: {
              company_id: companyId,
            },
          },
        },
      })
      setNewCountryCode(values?.countryDialingCode)
      setNewPhone(values?.contactNumber)
      handleSubmit(values)
    } else {
      onSubmit(values)
    }
  }
  // const getForgotedPassword = async () => {
  //   if (currentUser?.email) {
  //     try {
  //       setChangePasswordLoading(true)
  //       const {
  //         data: { success },
  //       } = await forgotPassword(currentUser?.email)
  //       if (success) {
  //         setShowModal(true)
  //         setHasErrors(false)
  //         TagManager.dataLayer({
  //           dataLayer: {
  //             event: GTMEvent.ForgotPasswordSuccessful,
  //             action: 'normal',
  //             metadata: {
  //               email: currentUser?.email,
  //               user_id: currentUser?.userId,
  //               company_id: companyId,
  //             },
  //           },
  //         })
  //       } else {
  //         setHasErrors(true)
  //         TagManager.dataLayer({
  //           dataLayer: {
  //             event: GTMEvent.ForgotPasswordFailed,
  //             action: 'normal',
  //             metadata: {
  //               email: currentUser?.email,
  //               user_id: currentUser?.userId,
  //               company_id: companyId,
  //             },
  //           },
  //         })
  //       }
  //     } catch (error) {
  //       console.log(error)
  //       TagManager.dataLayer({
  //         dataLayer: {
  //           event: GTMEvent.ForgotPasswordFailed,
  //           action: 'normal',
  //           metadata: {
  //             email: currentUser?.email,
  //             user_id: currentUser?.userId,
  //             company_id: companyId,
  //           },
  //         },
  //       })
  //     } finally {
  //       setChangePasswordLoading(false)
  //     }
  //   }
  // }

  const handleOpen = () => {
    setModelStatus(true)
  }
  const handleClose = () => {
    setModelStatus(false)
  }
  const handleSubmit = async (values: any) => {
    setLoading(true)
    try {
      const payload: any = {
        countryDialingCode: values?.countryDialingCode,
        phoneNumber: values?.contactNumber,
      }
      const {
        data: { data, success, errors },
      } = await createOtp(+companyId!, payload)
      if (success) {
        localStorage.setItem('countryDialingCode', values?.countryDialingCode)
        localStorage.setItem('phoneNumber', values?.phoneNumber)
        setShowModal(true)
        toast.success(formatMessage({ id: data }))
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className='settings-container h-auto p-2'>
        {getApiLoading ? (
          <div className='col-xl-12 d-md-flex'>
            <div>
              <div className={`card position-relative d-flex justify-content-center`}>
                <Skeleton
                  height={130}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />{' '}
              </div>
            </div>
            <div className='mt-md-8 ms-md-16 w-100 px-5 px-md-0 mb-4'>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2 w-25'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2 w-25'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
              <div className='w-100 d-md-flex justify-content-md-end gap-4 align-items-md-end h-md-200px'>
                <div className='w-md-25'>
                  <Skeleton
                    height={40}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />{' '}
                </div>
                <div className='w-md-25 me-md-20 mt-2'>
                  <Skeleton
                    height={40}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />{' '}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className='col-xl-12 d-md-flex'>
            {/* file upload  */}
            <div>
              <div
                className={`card position-relative d-flex justify-content-center`}
                onClick={handleOpen}
              >
                <DisplayImage
                  imgName={imgName}
                  height='100%'
                  width='100%'
                  fit='contain'
                  alt={formatMessage({ id: 'profile' })}
                />

                <div className='pencil-container'>
                  <img src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')} alt='' />
                </div>
              </div>
              <div style={{
                marginLeft: '16px',
                font: 'Poppins',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '18px',
                color: '#8898A6',
              }} >
                <p className='mb-0 font-size-12px text-muted'>{formatMessage({ id: 'Recommended' })}</p>
                <p className='mb-0 font-size-12px text-muted'>{formatMessage({ id: 'size: 512x512 px (1:1 Ratio)' })}</p>
                <p className='mb-0 font-size-12px text-muted'>{formatMessage({ id: 'JPG or PNG. Max size: 2MB' })}</p>
              </div>
            </div>

            <div className='mt-md-8 ms-md-16 w-100 px-5 px-md-0'>
              <Formik
                initialValues={userInitialValues}
                validationSchema={userSchema}
                onSubmit={saveChanges}
              >
                {(formik: any) => {
                  setCountryId(formik.values.country)
                  return (
                    <Form>
                      <div className='d-md-flex col-md-12 flex-wrap'>
                        <TextInput
                          fieldType={'text'}
                          label={formatMessage({ id: 'First Name' })}
                          fieldName={'firstName'}
                          formik={formik}
                          placeholder=''
                          margin='me-6'
                          toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.USER.FIRST_NAME' })}
                          width={5}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        <FileUpload
                          fileSize={2097152}
                          maxFileNumber={1}
                          allowType={['image/*', '.jpg', '.jpeg', '.png']}
                          metaData={{ module: 'profileimg', isProtected: false }}
                          modalStatus={modelStatus}
                          handleClose={handleClose}
                          handleSuccess={(id: number, name: string) => {
                            setImgName(name)
                            formik.setFieldValue('profileImageId', id)
                          }}
                          resourceType='user_profile'
                        />
                        <TextInput
                          fieldType={'text'}
                          label={formatMessage({ id: 'Last Name' })}
                          fieldName={'lastName'}
                          formik={formik}
                          placeholder=''
                          margin='me-4'
                          toolTipText={formatMessage({ id: 'Please enter your legal last name and avoid nicknames.' })}
                          width={5}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        <SelectInput
                          label={formatMessage({ id: 'Position' })}
                          fieldName={'designation'}
                          placeholder={formatMessage({ id: 'Select your Position' })}
                          formik={formik}
                          toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.USER.POSITION' })}
                          options={designationOptions}
                          margin='me-md-6'
                          width={5}
                          onBlur={formik.handleBlur}
                        />
                        <TextInput
                          fieldType={'email'}
                          fieldName={'email'}
                          formik={formik}
                          placeholder={''}
                          label={formatMessage({ id: 'Email Address' })}
                          toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.USER.EMAIL' })}
                          width={5}
                          isStarRequired={true}
                          isDisabled={true}
                          onBlur={formik.handleBlur}
                        />
                        <SelectInput
                          label={formatMessage({ id: "Country" })}
                          fieldName={'country'}
                          placeholder={formatMessage({ id: 'Select Your Country' })}
                          formik={formik}
                          toolTipText={formatMessage({ id: 'Please select the country where you are residing currently.' })}
                          options={countryOptions}
                          width={5}
                          margin={'me-md-6'}
                          onBlur={formik.handleBlur}
                        />
                        <SelectInput
                          label={formatMessage({ id: 'State/Province' })}
                          fieldName={'state'}
                          placeholder={formatMessage({ id: 'Select Your State or Province' })}
                          formik={formik}
                          toolTipText={formatMessage({ id: 'Please select the State/Province where you are presently located.' })}
                          options={stateOptions}
                          width={5}
                          onBlur={formik.handleBlur}
                        />
                        <TextInput
                          fieldType={'city'}
                          fieldName={'city'}
                          formik={formik}
                          placeholder={'Enter City'}
                          label={formatMessage({ id: 'City' })}
                          toolTipText={formatMessage({ id: 'Please specify the city where you are located.' })}
                          width={5}
                          margin={'me-md-6'}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        <TextInput
                          fieldType={'number'}
                          fieldName={'zipCode'}
                          formik={formik}
                          placeholder={'Enter Zip Code'}
                          label={formatMessage({ id: 'Zip Code' })}
                          toolTipText={formatMessage({ id: 'Please provide the ZIP code your residing city.' })}
                          width={5}
                          isStarRequired={true}
                          onBlur={formik.handleBlur}
                        />
                        {/* <TextInput
                          fieldType={'number'}
                          fieldName={'contact'}
                          formik={formik}
                          placeholder={''}
                          margin='me-6'
                          label={formatMessage({id: 'Contact Number'})}
                          toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.USER.CONTACT_NUMBER'})}
                          width={5}
                          isStarRequired={false}
                          isDisabled={!!formik.initialValues.contact}
                        /> */}
                        <InputWithPhone
                          label={formatMessage({ id: 'Phone' })}
                          toolTipText={formatMessage({ id: 'Enter Phone number' })}
                          fieldName='contactNumber'
                          placeholder={formatMessage({ id: 'Enter Phone Number' })}
                          placeholderSelect={formatMessage({ id: 'Select' })}
                          formik={formik}
                          options={phoneCodesOptions}
                          selectOptionFieldName='countryDialingCode'
                          isStarRequired
                          width={5}
                          margin={'me-md-6'}
                          onBlur={formik.handleBlur}
                        />
                        {/* <div className='d-md-flex flex-md-column'>
                          <div className='d-inline-block form-label text-dark font-size-13'>
                            {formatMessage({ id: 'Communication' })}{' '}
                            <ToolTipUI
                              tooltipText={formatMessage({ id: 'GLOBAL.TOOLTIP.USER.COMMUNICATION' })}
                            />
                          </div>
                          <div className='d-md-flex'>
                            <TextInput
                              fieldName={'communication.email'}
                              formik={formik}
                              customText={formatMessage({ id: 'Email' })}
                              placeholder=''
                              fieldType={'checkbox'}
                              isCheckbox={true}
                              isTooltipNotRequired={true}
                              margin={'me-20 mt-n8'}
                              onBlur={formik.handleBlur}
                            />
                            <TextInput
                              fieldName={'communication.phone'}
                              formik={formik}
                              customText={formatMessage({ id: 'Phone' })}
                              placeholder=''
                              fieldType={'checkbox'}
                              isCheckbox={true}
                              isTooltipNotRequired={true}
                              margin={'mt-n8'}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                        </div> */}
                      </div>
                      <div className='d-md-flex justify-content-end button-margin me-md-10 mb-4'>
                        {/* <div className='d-grid mb-md-10 mb-2 me-md-3 w-100 w-md-auto'>
                          <BasicButton
                            buttonText={formatMessage({ id: 'Change password' })}
                            onClick={getForgotedPassword}
                            disabled={changePasswordLoading}
                            loading={changePasswordLoading}
                            height='44px'
                            border='1px solid #4776E6'
                            // color='white'
                            textColor='#4776E6'
                            padding='12px 24px'
                          />
                        </div> */}
                        {/* <CustomButton
                          isSubmitting={formik.isSubmitting}
                          isValid={formik.isValid}
                          buttonText={formatMessage({id: 'Save Changes'})}
                          loading={loading}
                          width={2}
                          widthLoading={2}
                          margin={'me-md-3'}
                          height={44}
                        /> */}
                        <BasicButton
                          buttonText={formatMessage({ id: 'Save Changes' })}
                          customClass='bg-primary custom-button-property text-white w-100 w-md-auto'
                          loading={loading}
                          onClick={() => saveChanges(formik.values)}
                          disabled={!formik.isValid || loading}
                        />
                      </div>
                    </Form>
                  )
                }}
              </Formik>
            </div>
          </div>
        )}

        {/* <ChangePasswordModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          setShowModal={setShowModal}
        /> */}
        <OTPModal
          showModal={showModal}
          setShowModal={setShowModal}
          countryCode={newCountryCode}
          phone={newPhone}
          getProfileInfo={getProfileInfo}
        />
      </div>
    </>
  )
}
